"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineAlertWidget = exports.AlertStyleName = exports.InlineAlertType = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var ButtonWidget_1 = require("../Button/ButtonWidget");
var InlineAlertBase_1 = require("./InlineAlertBase");
Object.defineProperty(exports, "InlineAlertType", { enumerable: true, get: function () { return InlineAlertBase_1.InlineAlertType; } });
var VerticalPadding = 8;
var ButtonContainerClass = 'buttonContainer';
exports.AlertStyleName = TypeStyle.style({
    paddingTop: VerticalPadding,
    $nest: (_a = {},
        _a["& ." + InlineAlertBase_1.ContentClass] = {
            flexWrap: 'wrap',
            // We use offsetting margin + padding here accommodate wrapping behavior
            // This allows the button to wrap underneath the text, without causing extra height when not wrapped
            marginBottom: -VerticalPadding,
            paddingBottom: VerticalPadding,
        },
        _a["& ." + InlineAlertBase_1.MessageClass] = {
            margin: "3px 16px " + VerticalPadding + "px 8px",
        },
        _a["& ." + ButtonContainerClass] = {
            margin: "0px 16px " + VerticalPadding + "px 8px",
        },
        _a)
});
var InlineAlertButton = function (button) {
    return React.createElement("div", { className: ButtonContainerClass }, React.cloneElement(button, {
        buttonType: ButtonWidget_1.ButtonType.Outline,
    }));
};
exports.InlineAlertWidget = React.forwardRef(function (props, ref) {
    var button = props.button, className = props.className, inlineAlertProps = tslib_1.__rest(props, ["button", "className"]);
    return (React.createElement(InlineAlertBase_1.InlineAlert, tslib_1.__assign({}, inlineAlertProps, { className: TypeStyle.classes(className, exports.AlertStyleName), interactiveElement: button && InlineAlertButton(button), ref: ref })));
});
exports.InlineAlertWidget.displayName = 'InlineAlertWidget';
//# sourceMappingURL=InlineAlertWidget.js.map